import { parse, format } from 'date-fns';

export const transformVisitStatsData = (
	apiData: AnalyticsApiResponse,
): VisitStatsData[] => {
	return apiData.rows.map((row: Row) => {
		const rawDate = row.dimensionValues[0].value;

		// Use date-fns to parse the date string
		const _date = parse(rawDate, 'yyyyMMdd', new Date());

		return {
			date: format(_date, 'MMM d'),
			sessions: parseInt(row.metricValues[0].value, 10),
			activeUsers: parseInt(row.metricValues[1].value, 10),
			bounceRate: parseFloat(
				(parseFloat(row.metricValues[2].value) * 100).toFixed(2),
			),
			engagementDuration: parseInt(row.metricValues[3].value), // engagementDuration is in seconds
		};
	});
};

export const transformUserSourceData = (
	apiData: AnalyticsApiResponse,
): UserSourceData[] => {
	return apiData.rows.map((row) => ({
		channel: row.dimensionValues[0].value, // Get the sessionDefaultChannelGrouping value
		activeUsers: parseInt(row.metricValues[0].value, 10), // Get the activeUsers value
	}));
};

export const transformPageViewsData = (
	apiData: AnalyticsApiResponse,
): PageViewsData[] => {
	return apiData.rows.map((row) => ({
		pageTitle: row.dimensionValues[0].value, // Get the pageTitle value
		screenPageViews: parseInt(row.metricValues[0].value, 10), // Get the screenPageViews value
	}));
};

export const transformEventCountData = (
	apiData: AnalyticsApiResponse,
): EventCountData[] => {
	return apiData.rows.map((row) => ({
		eventName: row.dimensionValues[0].value, // Get the event name
		eventCount: parseInt(row.metricValues[0].value, 10), // Get the event count
		totalUsers: parseInt(row.metricValues[1].value, 10), // Get the total number of users
	}));
};
